//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["eventId"],"UnregisterUserdefinedFunctions",{},1,0],[["eventId","src_occ","target_occ"],"CallUserdefinedFunctions",{},3,0],[["eventId"],"IsUserdefinedFunctionAvailable",{},1,0]],[]];
SPLM.LineDesigner.LineDesignerUserCallBackManager = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.LineDesignerUserCallBackManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.LineDesigner.LineDesignerUserCallBackManager.EventType = Object.freeze({
    "PasteEvent" : "PasteEvent", "EndPasteEvent" : "EndPasteEvent", "ComponentReplaceEvent" : "ComponentReplaceEvent"});

export default SPLM;